import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@frontegg/react";
import { useBrandingContext } from "context/BrandingContext";
import AppShell from "./AppShell";
import { useSidebarItems } from "hooks/useSideBarItems";
import { useAppEntitlements } from "hooks/useAppEntitlements";
import IntegrationDisconnectedPrompt from "../admin/IntegrationDisconnectedPrompt";
import DashboardQuickActions from "../admin/dashboard/DashboardQuickActions";
import ByocQuickActions from "../admin/byocDashboard/QuickActions";
import { useIsSmallScreen } from "../../hooks/useIsSmallScreen";
import { CircularProgress } from "@mui/material";
import { setLastSystem } from "../../utils/lastSystem";
import { getImpersonationFromStorage } from "../../contexts/ImpersonationContext";

const LayoutAdmin: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  const { platform } = useBrandingContext();
  const footerDisclosure = platform?.footerDisclosure || "";

  const isSmallScreen = useIsSmallScreen();
  const { byocOnly } = useAppEntitlements();
  const { sidebarItems, subSideBarItems } = useSidebarItems();
  const [isSideBarSmallScreenOpen, setIsSideBarSmallScreenOpen] =
    useState<boolean>(false);

  const handleCollapsed = () => {
    setIsSideBarSmallScreenOpen(!isSideBarSmallScreenOpen);
  };

  useEffect(() => {
    if (!isSmallScreen) {
      setIsSideBarSmallScreenOpen(false);
    }
  }, [isSmallScreen]);

  useEffect(() => {
    if (getImpersonationFromStorage()) return;
    setLastSystem("spend");
  }, []);

  if (isLoading)
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress color="primary" />
      </div>
    );

  return (
    <AppShell
      basePath="/admin"
      items={sidebarItems}
      subItems={subSideBarItems}
      isSmallScreen={isSmallScreen}
      isSideBarSmallScreenOpen={isSideBarSmallScreenOpen}
      handleCollapsed={handleCollapsed}
      footerDisclosure={footerDisclosure}
      prompts={<IntegrationDisconnectedPrompt />}
      leadingActions={
        // Dashboard only, and only where the bar has room for them: below `md`
        // the left section is already the menu button and the logo.
        location.pathname.startsWith("/admin/dashboard") && !isSmallScreen ? (
          byocOnly ? (
            <ByocQuickActions />
          ) : (
            <DashboardQuickActions />
          )
        ) : undefined
      }
    />
  );
};

export default LayoutAdmin;
